import dominik from '@/assets/img/dominik.jpg';
import { Guardian } from '@/components/ui/ClientCard';
import { KASKA_CONSULTANT } from '@/consts';

export const CONSULTANTS = {
  JOANNA_ASSISTANT: KASKA_CONSULTANT,
  BARTOSZ_EXPERT: KASKA_CONSULTANT,
  MARTA_ASSISTANT: KASKA_CONSULTANT,
  EWELINA_ASSISTANT: KASKA_CONSULTANT,
  KASIA_ASSISTANT: {
    ...KASKA_CONSULTANT,
    jobDescription: 'Ekspert ds. odszkodowań',
  },
  //Dominik Dopierała
  DOMINIK_ASSISTANT: {
    name: 'Dominik Dopierała',
    email: 'dominik@deepdry.pl',
    image: dominik,
    phoneNumber: '+48 538 233 940',
    jobDescription: 'Ekspert ds. odszkodowań',
  },
} as const satisfies Record<
  Uppercase<string>,
  Guardian & { jobDescription: string }
>;
